window.portalModule.factory 'PortalAccessService',
['$q', '$log', '$state',
($q, $log, $state) ->
  $log = $log.getInstance('PortalAccessService')

  hasRetired = (practice) ->
    practice?.is_patient_fusion_retired is true

  # Naming one practice is only honest when a single practice is involved; the
  # message falls back to 'your practice' otherwise.
  soleRetiredPracticeName = (practices) ->
    return null unless practices.length is 1
    practices[0].practice_name

  showRetiredMessage = (practices) ->
    $state.go 'practice_retired', practiceName: soleRetiredPracticeName(practices)
    $q.reject('practice-retired')

  redirectWhenNoRecordsRemain: (phrPatients) ->
    return phrPatients unless _.isEmpty(phrPatients?.data)

    departedPractices = phrPatients?.departedPractices or []
    return phrPatients if _.isEmpty(departedPractices)

    # Retirement is answered here rather than by sending the patient to the login
    # app. FollowMyHealth onboarding does not change the answer: a retired
    # practice gets the retired message either way, which is what the pending
    # invite route already does and what the patient needs to read.
    retiredPractices = _.filter departedPractices, hasRetired
    return phrPatients if _.isEmpty(retiredPractices)

    $log.log 'no records remain in Patient Fusion; showing the retired-practice message'
    showRetiredMessage(retiredPractices)
]
